import { render, staticRenderFns } from "./no-data-empty.vue?vue&type=template&id=50bc4a6c"
import script from "./no-data-empty.js?vue&type=script&lang=js&external"
export * from "./no-data-empty.js?vue&type=script&lang=js&external"
import style0 from "./no-data-empty.vue?vue&type=style&index=0&id=50bc4a6c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-admin-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bc4a6c')) {
      api.createRecord('50bc4a6c', component.options)
    } else {
      api.reload('50bc4a6c', component.options)
    }
    module.hot.accept("./no-data-empty.vue?vue&type=template&id=50bc4a6c", function () {
      api.rerender('50bc4a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/no-data-empty/no-data-empty.vue"
export default component.exports